import * as Bixby from './../../core';

export interface CloDealHoldingForBixbyIdMappingState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  cloDealHoldingForBixbyIdMappings?: Bixby.Models.CloDealHoldingForBixbyIdMapping[];
}

export const ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS = "ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS";
export const ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE = 'ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE';
export const ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING = "ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING";

interface AllCloDealHoldingForBixbyIdMappingLoading extends Bixby.Models.BixbyAction<undefined, typeof ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING> {
  type: typeof ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_LOADING;
}

interface AllCloDealHoldingForBixbyIdMappingSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloDealHoldingForBixbyIdMapping[], typeof ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS> {
  type: typeof ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_SUCCESS;
}

interface AllCloDealHoldingForBixbyIdMappingFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE> {
  type: typeof ALL_CLO_DEAL_HOLDING_FOR_BIXBYID_MAPPING_FAILURE;
}

export type CloDealActionTypes =
  | AllCloDealHoldingForBixbyIdMappingLoading
  | AllCloDealHoldingForBixbyIdMappingSuccess
  | AllCloDealHoldingForBixbyIdMappingFailure;
